export default __webpack_public_path__ + "static/media/ticket13.dec83ffa.jpg";